/*
 * Navigation tabs component
 *
 * @param {String} tab Active tab
 * @param {Boolean} disabled Disabled tab
 *
 * @return {Element}
 */
<template>
  <div>
    <ul class="nav nav-tabs promotion-nav-tabs" id="tabTitle">
      <template v-for="item in navTabs">
        <li :id="item.id" :class="activeTab(item.id)" :key="item.id" v-if="disabled && item.id !== 'top'" class="disabled">
          <a>
            {{ item.name }}
          </a>
        </li>
        <li :id="item.id" v-else :class="activeTab(item.id)" :key="item.id" @click="changeTab(item.id)">
          <a>
            {{ item.name }}
          </a>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import tabs from '@/common/promotion-tabs'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  data () {
    return {
      navTabs: tabs
    }
  },
  props: {
    tab: {
      type: String,
      default: 'top'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /*
     * Check tab is active or not
     *
     * @param {String} tabName Tab's name
     *
     * @return {String}
     */
    activeTab (tabName) {
      return this.tab === tabName ? 'active' : ''
    },
    /*
     * Change tab
     *
     * @param {String} tabName Tab's name
     *
     * @return void
     */
    changeTab (tabName) {
      let availableTabs = ['top', 'promotion-request', 'promotion-info']
      if (availableTabs.includes(tabName)) {
        let logParamsName = eventCode.promotion.top_tab.show
        if (tabName === 'promotion-request') {
          logParamsName = eventCode.promotion.request_tab.show
        } else if (tabName === 'promotion-info') {
          logParamsName = eventCode.promotion.info_tab.show
        }

        setTimeout(() => {
          $(`#${tabName}`).addClass('disabled-tab')
        }, 100)

        let logParams = {
          name: logParamsName,
          properties: {}
        }
        EventService.postTrackLog(logParams)
      }

      this.$router.push(`/promotion/${tabName}`)
    }
  },
  mounted () {
    $(`#${this.tab}`).addClass('disabled-tab')
  }
}
</script>

<style scoped>
.disabled-tab {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/view/promotion/NavTabs.vue